/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Viewer, ViewerInterface } from "../Viewer";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract Staking",
        name: "_staking",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "getBondedValidatorInfos",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "valAddr",
            type: "address",
          },
          {
            internalType: "enum DataTypes.ValidatorStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "signer",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokens",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "shares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minSelfDelegation",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "commissionRate",
            type: "uint64",
          },
        ],
        internalType: "struct DataTypes.ValidatorInfo[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_delAddr",
        type: "address",
      },
    ],
    name: "getDelegatorInfos",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "valAddr",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokens",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "shares",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "creationBlock",
                type: "uint256",
              },
            ],
            internalType: "struct DataTypes.Undelegation[]",
            name: "undelegations",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "undelegationTokens",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawableUndelegationTokens",
            type: "uint256",
          },
        ],
        internalType: "struct DataTypes.DelegatorInfo[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_delAddr",
        type: "address",
      },
    ],
    name: "getDelegatorTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMinValidatorTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
    ],
    name: "getValidatorInfo",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "valAddr",
            type: "address",
          },
          {
            internalType: "enum DataTypes.ValidatorStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "signer",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokens",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "shares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minSelfDelegation",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "commissionRate",
            type: "uint64",
          },
        ],
        internalType: "struct DataTypes.ValidatorInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getValidatorInfos",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "valAddr",
            type: "address",
          },
          {
            internalType: "enum DataTypes.ValidatorStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "signer",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokens",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "shares",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minSelfDelegation",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "commissionRate",
            type: "uint64",
          },
        ],
        internalType: "struct DataTypes.ValidatorInfo[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
    ],
    name: "shouldBondValidator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "staking",
    outputs: [
      {
        internalType: "contract Staking",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60a060405234801561001057600080fd5b506040516117c73803806117c783398101604081905261002f91610040565b6001600160a01b0316608052610070565b60006020828403121561005257600080fd5b81516001600160a01b038116811461006957600080fd5b9392505050565b6080516116db6100ec6000396000818160bb01528181610199015281816102eb0152818161039701528181610633015281816107790152818161089e0152818161099b01528181610a4401528181610b0001528181610cf401528181610e3a01528181610ecf01528181610fec015261109201526116db6000f3fe608060405234801561001057600080fd5b50600436106100885760003560e01c80638dc2336d1161005b5780638dc2336d1461012a578063c6fc1ed614610140578063d87ffe9114610168578063e9fe6b0b1461017057600080fd5b8063313019bb1461008d5780634cf088d9146100b657806366ab5d28146100f55780638a11d7c91461010a575b600080fd5b6100a061009b36600461115b565b610193565b6040516100ad919061117f565b60405180910390f35b6100dd7f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b0390911681526020016100ad565b6100fd61062d565b6040516100ad91906112d7565b61011d61011836600461115b565b610839565b6040516100ad9190611319565b610132610996565b6040519081526020016100ad565b61015361014e36600461115b565b610c49565b604080519283526020830191909152016100ad565b6100fd610cee565b61018361017e36600461115b565b610ea7565b60405190151581526020016100ad565b606060007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316631cfe4f0b6040518163ffffffff1660e01b815260040160206040518083038186803b1580156101f057600080fd5b505afa158015610204573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610228919061132d565b905060008167ffffffffffffffff81111561024557610245611346565b6040519080825280602002602001820160405280156102b857816020015b6102a56040518060c0016040528060006001600160a01b0316815260200160008152602001600081526020016060815260200160008152602001600081525090565b8152602001906001900390816102635790505b5090506000805b838163ffffffff1610156104b7576040516324aec90f60e21b815263ffffffff821660048201526000907f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906392bb243c9060240160206040518083038186803b15801561033557600080fd5b505afa158015610349573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061036d919061135c565b604051631dd9dfdf60e31b81526001600160a01b03808316600483015289811660248301529192507f00000000000000000000000000000000000000000000000000000000000000009091169063eecefef89060440160006040518083038186803b1580156103db57600080fd5b505afa1580156103ef573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261041791908101906113f6565b848363ffffffff168151811061042f5761042f611527565b6020026020010181905250838263ffffffff168151811061045257610452611527565b60200260200101516040015160001415806104915750838263ffffffff168151811061048057610480611527565b602002602001015160800151600014155b156104a457826104a081611553565b9350505b50806104af81611553565b9150506102bf565b5060008163ffffffff1667ffffffffffffffff8111156104d9576104d9611346565b60405190808252806020026020018201604052801561054c57816020015b6105396040518060c0016040528060006001600160a01b0316815260200160008152602001600081526020016060815260200160008152602001600081525090565b8152602001906001900390816104f75790505b5090506000805b858163ffffffff16101561062157848163ffffffff168151811061057957610579611527565b60200260200101516040015160001415806105b85750848163ffffffff16815181106105a7576105a7611527565b602002602001015160800151600014155b1561060f57848163ffffffff16815181106105d5576105d5611527565b6020026020010151838363ffffffff16815181106105f5576105f5611527565b6020026020010181905250818061060b90611553565b9250505b8061061981611553565b915050610553565b50909695505050505050565b606060007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316631cfe4f0b6040518163ffffffff1660e01b815260040160206040518083038186803b15801561068a57600080fd5b505afa15801561069e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106c2919061132d565b905060008167ffffffffffffffff8111156106df576106df611346565b60405190808252806020026020018201604052801561074657816020015b6040805160e08101825260008082526020808301829052928201819052606082018190526080820181905260a0820181905260c082015282526000199092019101816106fd5790505b50905060005b828163ffffffff161015610832576040516324aec90f60e21b815263ffffffff821660048201526107fc907f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906392bb243c906024015b60206040518083038186803b1580156107c457600080fd5b505afa1580156107d8573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610118919061135c565b828263ffffffff168151811061081457610814611527565b6020026020010181905250808061082a90611553565b91505061074c565b5092915050565b6040805160e081018252600080825260208201819052918101829052606081018290526080810182905260a0810182905260c0810191909152604051631f4a58fb60e31b81526001600160a01b038381166004830152600091829182918291829182917f0000000000000000000000000000000000000000000000000000000000000000169063fa52c7d8906024016101406040518083038186803b1580156108e157600080fd5b505afa1580156108f5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109199190611594565b995050509750505095509550955095506040518060e00160405280896001600160a01b0316815260200187600381111561095557610955611254565b8152602001866001600160a01b031681526020018581526020018481526020018381526020018267ffffffffffffffff168152509650505050505050919050565b6000807f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166389f9aab56040518163ffffffff1660e01b815260040160206040518083038186803b1580156109f257600080fd5b505afa158015610a06573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a2a919061132d565b60405163eb505dd560e01b81529091506001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000169063eb505dd590610a7a90600390600401611636565b60206040518083038186803b158015610a9257600080fd5b505afa158015610aa6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610aca919061132d565b811015610ad957600091505090565b60001960005b828110156108325760405163acc62ccf60e01b8152600481018290526000907f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03169063c8f9f98490829063acc62ccf9060240160206040518083038186803b158015610b5257600080fd5b505afa158015610b66573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b8a919061135c565b6040517fffffffff0000000000000000000000000000000000000000000000000000000060e084901b1681526001600160a01b03909116600482015260240160206040518083038186803b158015610be157600080fd5b505afa158015610bf5573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c19919061132d565b905082811015610c365791508180610c3657600094505050505090565b5080610c4181611650565b915050610adf565b6000806000610c5784610193565b905060008060005b83518163ffffffff161015610ce257838163ffffffff1681518110610c8657610c86611527565b60200260200101516020015183610c9d919061166b565b9250838163ffffffff1681518110610cb757610cb7611527565b60200260200101516080015182610cce919061166b565b915080610cda81611553565b915050610c5f565b50909590945092505050565b606060007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166389f9aab56040518163ffffffff1660e01b815260040160206040518083038186803b158015610d4b57600080fd5b505afa158015610d5f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d83919061132d565b905060008167ffffffffffffffff811115610da057610da0611346565b604051908082528060200260200182016040528015610e0757816020015b6040805160e08101825260008082526020808301829052928201819052606082018190526080820181905260a0820181905260c08201528252600019909201910181610dbe5790505b50905060005b828163ffffffff1610156108325760405163acc62ccf60e01b815263ffffffff82166004820152610e71907f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03169063acc62ccf906024016107ac565b828263ffffffff1681518110610e8957610e89611527565b60200260200101819052508080610e9f90611553565b915050610e0d565b604051631f4a58fb60e31b81526001600160a01b0382811660048301526000918291829182917f0000000000000000000000000000000000000000000000000000000000000000169063fa52c7d8906024016101406040518083038186803b158015610f1257600080fd5b505afa158015610f26573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f4a9190611594565b5050975050505050935050925060006003811115610f6a57610f6a611254565b836003811115610f7c57610f7c611254565b1480610f9957506003836003811115610f9757610f97611254565b145b15610fa957506000949350505050565b8067ffffffffffffffff16431015610fc657506000949350505050565b6040516347abfdbf60e01b81526001600160a01b038681166004830152600160248301527f000000000000000000000000000000000000000000000000000000000000000016906347abfdbf9060440160206040518083038186803b15801561102e57600080fd5b505afa158015611042573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906110669190611683565b61107557506000949350505050565b61107d610996565b821161108e57506000949350505050565b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166383cfb3186040518163ffffffff1660e01b815260040160206040518083038186803b1580156110e957600080fd5b505afa1580156110fd573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611121919061132d565b9050804310156111375750600095945050505050565b50600195945050505050565b6001600160a01b038116811461115857600080fd5b50565b60006020828403121561116d57600080fd5b813561117881611143565b9392505050565b60006020808301818452808551808352604092508286019150828160051b8701018488016000805b8481101561124557898403603f19018652825180516001600160a01b031685528881015189860152878101518886015260608082015160c0918701829052805191870182905260e0870191908b0190855b8181101561121d578251805185528d01518d850152928b0192918c01916001016111f8565b5050506080828101519087015260a091820151919095015294870194918701916001016111a7565b50919998505050505050505050565b634e487b7160e01b600052602160045260246000fd5b6001600160a01b0380825116835260208201516004811061128d5761128d611254565b8060208501525080604083015116604084015250606081015160608301526080810151608083015260a081015160a083015267ffffffffffffffff60c08201511660c08301525050565b6020808252825182820181905260009190848201906040850190845b818110156106215761130683855161126a565b9284019260e092909201916001016112f3565b60e08101611327828461126a565b92915050565b60006020828403121561133f57600080fd5b5051919050565b634e487b7160e01b600052604160045260246000fd5b60006020828403121561136e57600080fd5b815161117881611143565b60405160c0810167ffffffffffffffff8111828210171561139c5761139c611346565b60405290565b6040805190810167ffffffffffffffff8111828210171561139c5761139c611346565b604051601f8201601f1916810167ffffffffffffffff811182821017156113ee576113ee611346565b604052919050565b6000602080838503121561140957600080fd5b825167ffffffffffffffff8082111561142157600080fd5b9084019060c0828703121561143557600080fd5b61143d611379565b825161144881611143565b815282840151848201526040808401518183015260608401518381111561146e57600080fd5b8401601f8101891361147f57600080fd5b80518481111561149157611491611346565b61149f878260051b016113c5565b818152878101955060069190911b82018701908a8211156114bf57600080fd5b918701915b818310156114ff5783838c0312156114dc5760008081fd5b6114e46113a2565b835181528884015189820152865294870194918301916114c4565b60608501525050506080838101519082015260a0928301519281019290925250949350505050565b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052601160045260246000fd5b600063ffffffff8083168181141561156d5761156d61153d565b6001019392505050565b805167ffffffffffffffff8116811461158f57600080fd5b919050565b6000806000806000806000806000806101408b8d0312156115b457600080fd5b8a51600481106115c357600080fd5b60208c0151909a506115d481611143565b8099505060408b0151975060608b0151965060808b0151955060a08b0151945060c08b0151935061160760e08c01611577565b92506116166101008c01611577565b91506116256101208c01611577565b90509295989b9194979a5092959850565b602081016009831061164a5761164a611254565b91905290565b60006000198214156116645761166461153d565b5060010190565b6000821982111561167e5761167e61153d565b500190565b60006020828403121561169557600080fd5b8151801515811461117857600080fdfea264697066735822122019bf28395ff9208b8ffc28df374500326317e150ccd3b6a5cbf683eadd5b448d64736f6c63430008090033";

type ViewerConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: ViewerConstructorParams): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Viewer__factory extends ContractFactory {
  constructor(...args: ViewerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Viewer";
  }

  deploy(_staking: string, overrides?: Overrides & { from?: string | Promise<string> }): Promise<Viewer> {
    return super.deploy(_staking, overrides || {}) as Promise<Viewer>;
  }
  getDeployTransaction(
    _staking: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_staking, overrides || {});
  }
  attach(address: string): Viewer {
    return super.attach(address) as Viewer;
  }
  connect(signer: Signer): Viewer__factory {
    return super.connect(signer) as Viewer__factory;
  }
  static readonly contractName: "Viewer";
  public readonly contractName: "Viewer";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ViewerInterface {
    return new utils.Interface(_abi) as ViewerInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Viewer {
    return new Contract(address, _abi, signerOrProvider) as Viewer;
  }
}
